// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .reuse-decision-selector {
  margin-left: -6px;
  min-width: 150px;
}
.presize-root .reuse-decision-selector-dropdown {
  min-width: 150px;
}
.presize-root .reuse-decision-selector-button {
  border: none;
  box-shadow: none;
  margin-left: -6px;
}
.presize-root .reuse-decision-selector-button:hover {
  background-color: #fff;
}
.presize-root .anticon.reuse-decision-selector-button-icon {
  color: #a2a3a8;
}
.presize-root .reuse-decision-selector-button-separator:before {
  content: '·';
  font-weight: bold;
}
.presize-root .reuse-decision-label {
  cursor: pointer;
  margin-right: 4px;
  font-size: 12px;
  color: #66676e;
}
.presize-root .reuse-decision-selector-disabled {
  background-color: #efeff0;
  border-radius: 4px;
}
/*# sourceMappingURL=ReuseDecisionSelector.css.map */`, "",{"version":3,"sources":["webpack://./ReuseDecisionSelector.less","webpack://./src/components/SizingGroup/ReuseDecisionSelector/ReuseDecisionSelector.less"],"names":[],"mappings":"AAAA;EAEE,iBAAA;EACA,gBAAA;ACAF;ADHA;EAME,gBAAA;ACAF;ADNA;EASE,YAAA;EACA,gBAAA;EACA,iBAAA;ACAF;ADCE;EACE,sBAAA;ACCJ;ADdA;EAiBE,cAAA;ACAF;ADjBA;EAoBE,YAAA;EACA,iBAAA;ACAF;ADrBA;EAwBE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;ACAF;AD3BA;EA8BE,yBAAA;EACA,kBAAA;ACAF;AACA,oDAAoD","sourcesContent":[".presize-root { \n .reuse-decision-selector {\n  margin-left: -6px;\n  min-width: 150px;\n}\n.reuse-decision-selector-dropdown {\n  min-width: 150px;\n}\n.reuse-decision-selector-button {\n  border: none;\n  box-shadow: none;\n  margin-left: -6px;\n  &:hover {\n    background-color: #fff;\n  }\n}\n.anticon.reuse-decision-selector-button-icon {\n  color: #a2a3a8;\n}\n.reuse-decision-selector-button-separator:before {\n  content: '·';\n  font-weight: bold;\n}\n.reuse-decision-label {\n  cursor: pointer;\n  margin-right: 4px;\n  font-size: 12px;\n  color: #66676e;\n}\n.reuse-decision-selector-disabled {\n  background-color: #efeff0;\n  border-radius: 4px;\n}\n \n}",".presize-root .reuse-decision-selector {\n  margin-left: -6px;\n  min-width: 150px;\n}\n.presize-root .reuse-decision-selector-dropdown {\n  min-width: 150px;\n}\n.presize-root .reuse-decision-selector-button {\n  border: none;\n  box-shadow: none;\n  margin-left: -6px;\n}\n.presize-root .reuse-decision-selector-button:hover {\n  background-color: #fff;\n}\n.presize-root .anticon.reuse-decision-selector-button-icon {\n  color: #a2a3a8;\n}\n.presize-root .reuse-decision-selector-button-separator:before {\n  content: '·';\n  font-weight: bold;\n}\n.presize-root .reuse-decision-label {\n  cursor: pointer;\n  margin-right: 4px;\n  font-size: 12px;\n  color: #66676e;\n}\n.presize-root .reuse-decision-selector-disabled {\n  background-color: #efeff0;\n  border-radius: 4px;\n}\n/*# sourceMappingURL=ReuseDecisionSelector.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
